import { ClipboardListIcon, DownloadIcon, FileTextIcon, FlagIcon, LayoutGridIcon, ShieldIcon, UsersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { MessageKey } from '../i18n';
import type { ViewId } from '../types';

export interface DrawerNavItem {
  readonly id: ViewId;
  readonly labelKey: MessageKey;
  readonly icon: LucideIcon;
}

export const NAV: readonly DrawerNavItem[] = [
  { id: 'registrationData', labelKey: 'nav.registrationData', icon: ClipboardListIcon },
  { id: 'competitions', labelKey: 'nav.competitions', icon: FlagIcon },
  { id: 'clubs', labelKey: 'nav.clubs', icon: ShieldIcon },
  { id: 'athletes', labelKey: 'nav.athletes', icon: UsersIcon },
  { id: 'starter', labelKey: 'nav.starter', icon: LayoutGridIcon },
  { id: 'programme', labelKey: 'nav.programme', icon: FileTextIcon },
  { id: 'entries', labelKey: 'nav.entries', icon: DownloadIcon },
];

